import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, rememberPremiumFunnelOrigin } from '@utils/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(rememberPremiumFunnelOrigin))
